import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'Loading' })((theme) => ({
  loadingContainer: {
    width: '100%',
    height: '100%',
    minHeight: '50vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingLabel: {
    paddingTop: theme.spacing(2),
  },
}));

export default useStyles;
